import React from "react";
import pic1 from "../assets/hz.jpg";
import resume from "../assets/resume.pdf";
import pic2 from "../assets/linkedin.png";
import pic3 from "../assets/github.png";
import pic13 from "../assets/telegram.webp";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section id="profile">
      <motion.div 
        className="section__pic-container"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <img src={pic1} alt="Akbarshoh Ismatov profile" className="profile-img" />
      </motion.div>
      <motion.div 
        className="section__text"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
      >
        <p className="section__text__p1">{t("hero_hi") || "Hello, I'm"}</p>
        <h1 className="title">Akbarshoh Ismatov</h1>
        <p className="section__text__p2">{t("hero_title") || "Frontend Developer"}</p>
        <div className="btn-container">
          <motion.a 
            href={resume} 
            download="Ismatov Akbarshoh Resume" 
            target="_blank" 
            rel="noreferrer" 
            className="btn btn-color-2 clickable"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Download CV
          </motion.a>
          <motion.a 
            href="#contact" 
            className="btn btn-color-1 clickable"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t("contact_title") || "Contact Info"}
          </motion.a>
        </div>
        <div id="socials-container">
          <motion.a 
            href="https://t.me/akbarshohi" 
            target="_blank" 
            rel="noreferrer" 
            className="clickable"
            whileHover={{ scale: 1.2, rotate: 5 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Telegram @akbarshohi"
          >
            <img src={pic13} alt="Telegram" className="icon social-icon clickable" />
          </motion.a>
          <motion.a 
            href="https://www.linkedin.com/in/akbarshoh-ismatov-4179b52a8/" 
            target="_blank" 
            rel="noreferrer" 
            className="clickable"
            whileHover={{ scale: 1.2, rotate: -5 }}
            whileTap={{ scale: 0.9 }}
            aria-label="LinkedIn"
          >
            <img src={pic2} alt="LinkedIn" className="icon social-icon clickable" />
          </motion.a>
          <motion.a 
            href="https://github.com/Akbarshoh404" 
            target="_blank" 
            rel="noreferrer" 
            className="clickable"
            whileHover={{ scale: 1.2, rotate: 5 }}
            whileTap={{ scale: 0.9 }}
            aria-label="GitHub"
          >
            <img src={pic3} alt="Github" className="icon social-icon clickable" />
          </motion.a>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
